import {autoserializeAs, inheritSerialization} from "dcerialize";
import type {ICustomSortable} from "../../base/ICustomSortable";
import type {Existing, IdentifiableModel, IdOf} from "../../base/IdentifiableModel";
import {createExisting} from "../../base/IdentifiableModel";
import type {ModificationTrackedModel} from "../../base/ModificationTrackedModel";
import type {SoftDeletableModel} from "../../base/SoftDeletableModel";
import {ModificationDetails} from "../../ModificationDetails";

export enum InspectionTypeReportType {
  Editor = "editor",
  Upload = "upload",
  Input = "input",
  HsTank = "hstank",
}

export class IdOnlyInspectionType implements IdentifiableModel {
  @autoserializeAs(() => Number)
  public id?: number;

  public static existing(id: IdOf<IdOnlyInspectionType>): Existing<IdOnlyInspectionType> {
    return createExisting(IdOnlyInspectionType, id);
  }
}

@inheritSerialization(() => IdOnlyInspectionType)
export class SimpleInspectionType extends IdOnlyInspectionType implements SoftDeletableModel, ICustomSortable {
  @autoserializeAs(() => String)
  public readonly name: string;
  @autoserializeAs(() => Number)
  public sortOrder: number;
  @autoserializeAs(() => String)
  public reportType: InspectionTypeReportType;
  @autoserializeAs(() => Boolean)
  public readonly isCurrent: boolean;
  @autoserializeAs(() => Boolean)
  public readonly inspectionEditingProhibited: boolean;
  @autoserializeAs(() => Boolean)
  public readonly isDeleted: boolean;
}

@inheritSerialization(() => SimpleInspectionType)
export class WritableInspectionType extends SimpleInspectionType {
  @autoserializeAs(() => Boolean)
  public automaticallyGeneratesResult: boolean;
}

@inheritSerialization(() => WritableInspectionType)
export class InspectionType extends WritableInspectionType implements ModificationTrackedModel {
  @autoserializeAs(() => ModificationDetails)
  public readonly modificationDetails?: ModificationDetails;
}

export class InspectionTypeTranslation implements ModificationTrackedModel {
  @autoserializeAs(() => String)
  public name: string;
  @autoserializeAs(() => ModificationDetails)
  public readonly modificationDetails?: ModificationDetails;
}
